<template>
  <!--社区页面-->
  <tk-container
    class="b-g-f"
    infiniteScroll
    ref="informationPostsInit"
    :probeType="0"
    @scroll="watchScroll"
    @loadingMore="getInformationPosts"
  >
    <!--帖子列表InformationPosts-->
    <template v-if="postsType === 'news'">
      <div
        v-for="(s, index) in InformationPosts"
        @click="$push({ path: '/common/articleDetail', query: { type: 'news', id: s.objectId } })"
        :key="`news${index}`"
      >
        <article-single :article-single="s" :article-index="index"></article-single>
      </div>
    </template>
    <template v-else>
      <div v-if="InformationPosts.length">
        <div
          style="border-bottom: 1px solid #f5f5f5;"
          class="posts-card p-x-12 p-b-12 p-t-10"
          v-for="(s, index) in InformationPosts"
          :key="`posts-card${index}`"
        >
          <!--头像与关注-->
          <tk-flex between>
            <tk-flex middle @click.native="$push({path: '/itsMine/postsProfile', query: {id: s.author.objectId}})">
              <tk-avatar size="30">
                <tk-image :src="s.author && s.author.avatar ? s.author.avatar : defaultImage" height="30" width="30"></tk-image>
              </tk-avatar>
              <tk-flex
                column
                style="line-height: 1;"
                class="m-l-10"
              >
                <div class="font-bold font-16">{{s.author && s.author.name ? s.author.name : '用户'}}</div>
              </tk-flex>
            </tk-flex>
            <div v-if="postsType !== 'post'">
              <div class="post-card-watch" v-if="!s.isWatch" @click.stop="watchAuthor(s, index)">关注</div>
              <div class="post-card-watch" v-else @click.stop="cancelAuthor(s, index)">取消关注</div>
            </div>
            <div v-else @click="deletePost(s, index)">
              <tk-icon size="20" :color="'#AFB1B8'">delete</tk-icon>
            </div>
          </tk-flex>
          <!--详情-->
          <div>
            <!--内容-->
            <div class="copy-text">
              <i
                class="p-t-10 copy-text text-area-pre"
                style="font-size: 15px !important;"
                v-html="getArticleText(s.content)"
              >
              </i>
              <!--v-if="judgeArticleText(s.content)"-->
              <i
                class="m-t-10 post-card-tips"
                 @click="goPostsDetail(s, index)"> 查看详情</i>
            </div>
            <!--图片-->
            <tk-flex
              :class="{ 'm-t-10': s.pictureCombination && s.pictureCombination.length }"
              v-if="s.pictureCombination"
              gutter="5"
              wrap
            >
              <template v-if="s.pictureCombination.length === 1">
                <tk-flex
                  v-for="(postsImage, index) in s.pictureCombination"
                  @click.native="viewImage(s)"
                  :key="`postsImage${index}`"
                  class="posts-card-image full-width"
                  style="padding-right: 76px;"
                >
                  <tk-image
                    style="height: 100%;width: 100%;"
                    :width="100"
                    :height="100"
                    oraign
                    :src="postsImage"
                  ></tk-image>
                </tk-flex>
              </template>
              <template v-if="s.pictureCombination.length > 1">
                <three-image-post
                  :image-arr="s.pictureCombination"
                  class="p-x-0"
                  :sign-width="40"
                ></three-image-post>
              </template>
            </tk-flex>
            <!--点赞评论提示-->
            <tk-flex
              middle
              between
              class="p-t-10"
              style="color: #999;"
            >
              <tk-flex
                middle
                between
                class="caption m-t&#45;&#45;5"
                :style="{ width: clientSide }"
              >
                <div>{{getFromNow(s.createdAt)}}</div>
                <div
                  v-if="(s.author && s.author.objectId ? s.author.objectId : '000000') === userInfo.objectId && postsType !== 'post'"
                  class="font-12 text-primary text-right"
                  @click="deletePost(s, index)"
                >删除</div>
              </tk-flex>
              <tk-flex class="font-13 text-light-grey">
                <div class="m-r-20" @click.stop="likesPosts(s, index)">
                  <tk-icon v-if="!judgeUserFans(s, userInfo.objectId)" size="20" color="#999" class="m-r-5 m-b-4">favorite</tk-icon>
                  <tk-icon v-else size="20" color="#FA3333" class="m-r-5 m-b-4">collected</tk-icon>
                  赞
                </div>
                <div @click="changeCommentsStatus(s)" style="width: 55px;">
                  <tk-icon size="20" color="#999" class="m-r-5 m-b-4">comment</tk-icon>
                  评论
                </div>
              </tk-flex>
            </tk-flex>
          </div>
          <!--点赞及评论-->
          <div
            class="posts-card-footer"
            style="margin-top: 6px;"
            v-if="s.userFans.length || s.reviewsPostsList.length"
            :class="{ 'p-b-5': !s.reviewsPostsList.length, 'p-t-5': s.userFans.length }"
          >
            <!--点赞-->
            <tk-flex
              wrap
              middle
              class="posts-card-footer-top p-x-10"
              v-if="s.userFans.length"
            >
              <tk-icon size="15" color="rgba(91, 108, 143, 1)" class="m-r-5">favorite</tk-icon>
              <tk-flex
                middle
                v-for="(m, index) in s.userFans"
                class="font-13 font-bold"
                :key="`posts-card-footer-top${index}`"
              >
                {{m.name}} <span v-if="index < (s.userFans.length - 1)">，</span>
              </tk-flex>
            </tk-flex>
            <!--评论-->
            <div
              class="posts-card-footer-bottom"
              v-if="s.reviewsPostsList.length"
            >
              <div
                v-for="(item, firstIndex) in s.reviewsPostsList"
                :key="`posts-card-footer-bottom${firstIndex}`"
                class="p-t-2"
                :class="{ 'posts-card-footer-bottom-active': isShowTouch &&
                       deleteRender.index === firstIndex && Object.keys(deleteRender.data).length,
                       'posts-card-footer-bottom-radius': firstIndex === (s.reviewsPostsList.length - 1),
                       'p-b-5': firstIndex === (s.reviewsPostsList.length - 1),
                       'p-t-5': !s.userFans.length && firstIndex === 0 }"
              >
                <tk-flex class="fill font-12">
                  <tk-flex column middle class="full-width">
                    <div
                      class="posts-card-footer-bottom-color p-x-10 full-width"
                      v-if="item.reviewer"
                      @touchstart="gtouchstart($event, item.reviewer, item, s, firstIndex)"
                      @touchmove="gtouchmove()"
                      @touchend="gtouchend(item.reviewer, item, s, firstIndex)"
                    >
                      <span class="font-bold">{{(item.reviewer.name ? item.reviewer.name : '用户') + '：'}}</span>
                      <span style="color: #000000;">{{item.reviewerContent ? item.reviewerContent : '无评论信息'}}</span>
                    </div>
                    <!--回复数据-->
                    <div
                      v-if="item.whatToReply && item.whatToReply.length"
                      class="full-width p-x-10"
                    >
                      <tk-flex
                        middle
                        between
                        class="full-width"
                        v-for="(m, index) in item.whatToReply"
                        :key="`whatToReply${index}`"
                      >
                        <div
                          class="posts-card-footer-bottom-color font-bold"
                        >
                          <span @click="enterReplytoe(m.replytoe, item, s, firstIndex)">{{m.replytoe.name}}</span>
                          <span class="m-x-5" style="font-weight: normal;color: #000000;">回复</span>
                          <span  @click.stop="enterReplytoe(m.recipient, item, s, firstIndex)">{{m.recipient.name + '：'}}</span>
                          <span style="font-weight: normal;color: #000000;">{{m.content}}</span>
                        </div>
                        <div
                          v-if="m.replytoe.objectId === userInfo.objectId"
                          class="delete-replytoe"
                          :style="{ background: isDelReplytoe ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255, 255, 255, 0)' }"
                          @click="deleteReplyToe(m.replytoe, s, firstIndex, index)"
                        >
                          <tk-icon :size="14" :color="isDelReplytoe ? '#eaeaea' : '#999'">lajixiang</tk-icon>
                        </div>
                      </tk-flex>
                    </div>
                  </tk-flex>
                </tk-flex>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--输入框-->
      <div
        class="comments"
        slot="footer"
        :style="{ minHeight: styleHeight + 'px' }"
        v-show="isCommentsShow && !footerStatus"
      >
        <tk-flex bottom class="full-width full-height">
          <div class="comments-bg">
            <textarea-autosize
              ref="textarea"
              :placeholder="placeholder"
              @focus.native.prevent="styleHeight = 58"
              @blur.native.prevent="getBlur()"
              style="padding-left: 8px;"
              class="comments-area fill p-y-5 p-r-4"
              name="opinion"
              id="postsTextarea"
              cols="40" rows="1"
              v-model="comments"
              :min-height="32"
              :max-height="350"
            >
            </textarea-autosize>
          </div>
          <div class="comments-btn text-right">
            <tkui-button @click="enterComments" :disabled="!comments" class="comments-btn-enter primary small raised">发送</tkui-button>
          </div>
        </tk-flex>
      </div>
    </template>
    <!--返回顶部按钮-->
    <div
      slot="footer"
      @click="backTop"
      v-show="isTop"
      :class="{ 'back-top': toggleFooter, 'back-footer-top': !toggleFooter }"
    >
      <tk-icon
        class="animate__animated animate__rotateIn"
        color="#D51613"
        size="35"
      >zhidingtop</tk-icon>
    </div>
    <!--确认删除弹框-->
    <tkui-dialog :show.sync="isShowDelete" center>
      <div class="subhead">
        您确定要删除该帖子吗？
      </div>
      <template slot="action">
        <button class="tkui-dialog-button" @click="isShowDelete = false">取消</button>
        <button class="tkui-dialog-button primary" :disabled="spinnerLoading" @click="submitDelete">确定</button>
      </template>
    </tkui-dialog>
    <!--删除评论弹框-->
    <tk-cover
      :show.sync="isShowTouch"
      :color="'rgba(255, 255, 255, 0)'"
      transition
    >
      <tk-flex
        middle
        column
        class="posts-detail-delete"
        :style="{ left: clientLeft - 32 + 'px', top: clientTop - 118 + 'px' }"
      >
        <div class="font-14 text-gray" @click="copyReviews()">复制</div>
        <div style="margin-top: 35px;" class="text-gray font-14" @click="deleteSelfReplytoe()">删除</div>
      </tk-flex>
    </tk-cover>
    <!--查看大图组件-->
    <view-big-image
      ref="potsContainerView"
      v-if="viewDetail && viewDetail.pictureCombination"
      :commodity-image="viewDetail.pictureCombination"
    ></view-big-image>
  </tk-container>
</template>

<script>
import articleSingle from '@/components/articleSingle'
import viewBigImage from '@/components/viewBigImage'
import { Image as VanImage } from 'vant'
import threeImagePost from '@/components/threeImagePost'
import { judgePosts } from '@/assets/help/posts'
import { mapState } from 'vuex'
const copy = require('clipboard-copy')
export default {
  components: {
    articleSingle,
    viewBigImage,
    threeImagePost,
    [VanImage.name]: VanImage
  },
  data () {
    return {
      styleHeight: 62,
      isTop: false, // 显示返回顶部按钮状态
      clientSide: '', // 图片展示尺寸
      watchPostUser: [], // 用户关注列表
      InformationPosts: [], // 帖子列表数组
      isShowDelete: false, // 删除帖子弹框
      enterLoading: false,
      isDelReplytoe: false, // 删除回复状态
      deleteRender: {
        recipient: {},
        data: {},
        index: 0
      },
      isShowTouch: false, // 长按后的的弹框
      timeOutEvent: 0, // 长按延时器定义
      clientTop: 0, // 弹框位置
      clientLeft: 0, // 弹框位置
      spinnerLoading: false, // 删除状态
      deletePosts: null, // 要删除的帖子
      deleteIndex: 0, // 要删除帖子的索引
      praiseDisable: false, // 点赞状态
      watchDisabled: false, // 关注状态
      commentsPosts: null, // 评论的帖子
      isCommentsShow: false, // 输入框显示状态
      placeholder: '评论', // 输入框提示
      recipient: null, // 接收人信息
      reviewsIndex: 0, // 回复人的索引
      reviewsData: null, // 回复人信息
      comments: '', // 评论内容
      viewDetail: null // 要查看大图的帖子或文章
    }
  },
  props: {
    postsType: {
      type: String,
      default: 'all'
    },
    profileId: {
      type: String
    }
  },
  watch: {
    // 监听输入框是否显示
    isCommentsShow (val) {
      if (val) {
        this.$store.commit('setFooterStatus', false)
      } else {
        this.$store.commit('setFooterStatus', true)
      }
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      },
      componentUpdated: function (el) {
        // el.focus()
      }
    }
  },
  computed: {
    ...mapState({
      // 箭头函数可使代码更简练
      toggleFooter: state => state.toggleFooter
    })
  },
  beforeRouteLeave (to, from, next) {
    this.clearSelector()
    this.$store.commit('setFooterStatus', true)
    this.isCommentsShow = false
    if (this.$tkUa.isAndorid && window.plus) {
      window.plus.key.removeEventListener('backbutton', this.onback)
    }
    next(true)
  },
  mounted () {
    // 获取显示器的宽
    let clientWidth = document.documentElement.clientWidth - 82
    this.clientSide = Number((clientWidth / 3).toFixed(2)) + 'px'
    // 监听物理返回键
    if (this.$tkUa.isAndorid && window.plus) {
      window.plus.key.addEventListener('backbutton', this.onback)
    }
  },
  methods: {
    /**
     * 监听页面滚动
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.$store.commit('setFooterStatus', true)
      this.isCommentsShow = false
      if (scrollTop > 12 && this.isTop) {
        return
      }
      this.isTop = scrollTop > 12
      this.$forceUpdate()
    },
    /*
    * 返回顶部操作
    */
    async backTop () {
      await this.$tkHelper.sleep(100)
      this.$refs.informationPostsInit.scrollTo(0)
    },
    /**
    * 监听物理返回键后的操作
    * @date: 2020/8/28
    */
    onback () {
      this.clearSelector()
      this.$store.commit('setFooterStatus', true)
      this.isCommentsShow = false
    },
    /**
     * 清除选中
     * @date: 2020/8/28
     */
    clearSelector () {
      if (window.getSelection()) {
        const selection = window.getSelection()
        selection.removeAllRanges()
      } else if (document.selection && document.selection.empty) {
        document.selection.empty()
        // document.selection.clear()
      }
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInitA () {
      this.$forceUpdate()
      this.InformationPosts = []
      this.$refs.informationPostsInit.resetInfiniteScroll()
    },
    /**
     * 数组去重
     * @date: 2020/3/31
     */
    unique (arr) {
      if (!Array.isArray(arr)) {
        return
      }
      return Array.from(new Set(arr))
    },
    /**
     * 用户关注列表
     * @date: 2020/3/30
     */
    async getUserWatch () {
      let watchPostUser = await this.$tkParse.getList('/classes/watchPostUser', {
        params: {
          limit: 10000,
          include: ['author'],
          where: {
            userFans: this.profileId
          }
        }
      })
      if (watchPostUser.length) {
        this.watchPostUser = watchPostUser.map(s => { return s.author.objectId })
        this.watchPostUser = this.unique(this.watchPostUser)
      } else {
        this.watchPostUser = []
      }
    },
    /**
     * 判断是否关注了作者
     * @date: 2020/3/30
     */
    async getPostsWatch (authorId) {
      let res = await this.$tkParse.getList(`/classes/watchPostUser`, {
        params: {
          limit: 1,
          where: {
            author: authorId,
            userFans: this.userInfo.objectId
          }
        }
      })
      return !!res.length
    },
    /**
     * 获取html中的文字
     * @date: 2020/3/23
     */
    getArticleText (html) {
      // return html.replace(/<\/?(img)[^>]*>/gi, '')
      let value = html.replace(/<\/?(img)[^>]*>/gi, '')
      if (value.length > 140) {
        return value.slice(0, 140) + '...'
      }
      return value
    },
    /**
     * 判断html中的文字
     * @date: 2020/8/5
     */
    judgeArticleText (html) {
      // return html.replace(/<\/?(img)[^>]*>/gi, '')
      let value = html.replace(/<\/?(img)[^>]*>/gi, '')
      return value.length > 140
    },
    /**
    * 帖子查看大图
    * @date: 2020/9/14
    */
    async viewImage (s) {
      this.viewDetail = null
      this.viewDetail = s
      await this.$tkHelper.sleep(0)
      this.$refs.potsContainerView.showImages()
    },
    /**
     * 帖子
     * @date: 2020/3/25
     */
    async getInformationPosts (page, next) {
      let InformationPosts = []
      if (this.postsType === 'watch') { await this.getUserWatch() }
      if (this.postsType === 'watch' && this.watchPostUser.length) { // 查询关注作者的帖子
        // this.watchPostUser.forEach(s => {
        //   this.$tkParse.batch.get(`/classes/InformationPosts`, {
        //     params: {
        //       skip: 20 * page,
        //       limit: 20,
        //       include: 'author',
        //       order: '-createdAt',
        //       where: {
        //         author: s
        //       }
        //     }
        //   })
        // })
        // let arr = await this.$tkParse.batch.run()
        let arr = []
        for (let i = 0; i < this.watchPostUser.length; i++) {
          let s = this.watchPostUser[i]
          let res = await this.$tkParse.get(`/classes/InformationPosts`, {
            params: {
              skip: 20 * page,
              limit: 20,
              include: 'author',
              order: '-createdAt',
              where: {
                author: s
              }
            }
          })
          arr.push(res)
        }
        arr.forEach(s => { InformationPosts = [...InformationPosts, ...s.data.results] })
      } else if (this.postsType === 'all') { // 全部帖子
        InformationPosts = await this.$tkParse.getList(`/classes/InformationPosts`, {
          params: {
            skip: 20 * page,
            limit: 20,
            include: 'author',
            order: '-createdAt'
          }
        })
      } else if (this.postsType === 'news') { // 资讯
        InformationPosts = await this.$tkParse.getList(`/classes/news`, {
          params: {
            skip: 20 * page,
            limit: 20,
            order: '-isTop, -createdAt'
          }
        })
      } else if (this.postsType === 'post') {
        InformationPosts = await this.$tkParse.getList(`/classes/InformationPosts`, {
          params: {
            skip: 20 * page,
            limit: 20,
            include: 'author',
            order: '-createdAt',
            where: {
              author: this.profileId
            }
          }
        })
      } else if (this.postsType === 'comment') {
        InformationPosts = await this.$tkParse.getList(`/classes/InformationPosts`, {
          params: {
            skip: 20 * page,
            limit: 20,
            include: 'author',
            order: '-createdAt',
            where: {
              commentUser: { $all: [this.profileId] }
            }
          }
        })
      } else if (this.postsType === 'like') {
        InformationPosts = await this.$tkParse.getList(`/classes/InformationPosts`, {
          params: {
            skip: 20 * page,
            limit: 20,
            include: 'author',
            order: '-createdAt',
            where: {
              likeUser: { $all: [this.profileId] }
            }
          }
        })
      } else if (this.postsType === 'myPraise') {
        InformationPosts = await this.$tkParse.getList(`/classes/InformationPosts`, {
          params: {
            skip: 20 * page,
            limit: 20,
            include: 'author',
            order: '-createdAt',
            where: {
              author: this.profileId,
              likeUser: { $exists: true }
            }
          }
        })
      }
      if (this.postsType !== 'news') {
        // 查询是否关注该作者
        for (let i = 0; i < InformationPosts.length; i++) {
          let s = InformationPosts[i]
          if (!s.userFans) { s.userFans = [] }
          if (!s.reviewsPostsList) { s.reviewsPostsList = [] }
          s.isWatch = await this.getPostsWatch(s.author.objectId)
        }
      }
      this.InformationPosts = [...this.InformationPosts, ...InformationPosts]
      if (InformationPosts.length < 20) {
        next('complete')
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
     * 关注作者
     * @date: 2020/3/25
     */
    async watchAuthor (s, index) {
      if (!s || !s.author) { return this.$tkGlobal.toast.add('未找到您要关注的用户') }
      if (this.watchDisabled) { return }
      if (s.author.objectId === this.userInfo.objectId) { return this.$tkGlobal.toast.add('不能关注自己哦') }
      this.watchDisabled = true
      // 数据
      let obj = {
        author: s.author.objectId,
        userFans: this.userInfo.objectId
      }
      let watchStatus = await judgePosts('watchPostUser', { userFans: this.userInfo.objectId, author: s.author.objectId })
      // 判断关注作者
      if (watchStatus) {
        this.$tkGlobal.toast.add('您已经关注了该作者')
        this.InformationPosts[index].isWatch = true
        await this.$tkHelper.sleep(500)
        this.watchDisabled = false
        return
      } else { // 给关注列表添加数据
        s.isWatch = true
        await this.$tkParse.post(`/classes/watchPostUser`, obj)
        this.InformationPosts[index].isWatch = true
        this.InformationPosts.forEach(m => {
          if (s.author.objectId === m.author.objectId) {
            m.isWatch = true
          }
        })
        this.$forceUpdate()
        this.$tkGlobal.toast.add('关注成功')
      }
      await this.$tkHelper.sleep(500)
      this.watchDisabled = false
    },
    /**
    * 取消关注
    * @date: 2020/8/20
    */
    async cancelAuthor (s, index) {
      if (!s || !s.author) { return this.$tkGlobal.toast.add('未找到您要取消的用户') }
      this.watchDisabled = true
      let watchStatus = await judgePosts('watchPostUser', { userFans: this.userInfo.objectId, author: s.author.objectId })
      if (watchStatus) { // 取消关注
        let res = await this.$tkParse.getList(`/classes/watchPostUser`, {
          params: {
            limit: 1,
            where: {
              userFans: this.userInfo.objectId,
              author: s.author.objectId
            }
          }
        })
        await this.$tkParse.delete(`/classes/watchPostUser/${res[0].objectId}`)
        this.InformationPosts[index].isWatch = false
        this.InformationPosts.forEach(s => {
          if (s.author.objectId === this.InformationPosts[index].author.objectId) {
            s.isWatch = false
          }
        })
        this.$tkGlobal.toast.add('取消关注成功')
      } else { // 给关注列表添加数据
        // 数据
        let obj = {
          author: s.author.objectId,
          userFans: this.userInfo.objectId
        }
        await this.$tkParse.post(`/classes/watchPostUser`, obj)
        this.$tkGlobal.toast.add('关注成功')
        this.InformationPosts[index].isWatch = true
        this.InformationPosts.forEach(s => {
          if (s.author.objectId === this.InformationPosts[index].author.objectId) {
            s.isWatch = true
          }
        })
      }
      this.$forceUpdate()
      setTimeout(e => { this.watchDisabled = false }, 500)
    },
    /**
     * 获取语意化时间渲染
     * @date: 2020/3/26
     */
    getFromNow (date) {
      return this.$tkDate(date).fromNow()
    },
    /**
     * 判断点赞数组
     * @date: 2020/3/30
     */
    judgeUserFans (item, id) {
      let index = item.userFans.findIndex(s => { return s.objectId === id })
      return index !== -1
    },
    /**
     * 点赞帖子
     * @date: 2020/3/26
     */
    async likesPosts (item, index) {
      if (!await this.judgeId(item.objectId, 'InformationPosts')) {
        this.InformationPosts.splice(index, 1)
        return this.$tkGlobal.toast.add('此贴子可能已删除')
      }
      if (this.praiseDisable) { return this.$tkGlobal.toast.add('您点的太快了') }
      this.praiseDisable = true
      // 数据
      if (!this.InformationPosts[index].likeUser) { this.InformationPosts[index].likeUser = [] }
      if (!this.InformationPosts[index].userFans) { this.InformationPosts[index].userFans = [] }
      if (!this.judgeUserFans(item, this.userInfo.objectId)) { // 点赞
        this.InformationPosts[index].userFans.push({
          objectId: this.userInfo.objectId,
          date: new Date().toISOString(),
          name: this.userInfo.name ? this.userInfo.name : '用户',
          phone: this.userInfo.phone,
          avatar: this.userInfo.avatar ? this.userInfo.avatar : this.defaultImage
        })
        this.InformationPosts[index].likeUser.push(this.userInfo.objectId)
        await this.$tkParse.put(`/classes/InformationPosts/${item.objectId}`,
          { userFans: this.InformationPosts[index].userFans,
            likeUser: this.InformationPosts[index].likeUser })
        await this.$tkParse.post('/classes/praisePosts', {
          InformationPosts: this.InformationPosts[index].objectId,
          praiseUser: this.InformationPosts[index].author.objectId,
          userFans: this.userInfo.objectId
        })
        this.$tkGlobal.toast.add('点赞成功')
        setTimeout(() => { this.praiseDisable = false }, 500)
        this.$forceUpdate()
        return
      }
      // 取消赞
      if (this.InformationPosts[index].userFans.length) {
        let findIndex = this.InformationPosts[index].userFans.findIndex(s => { return s.objectId === this.userInfo.objectId })
        this.InformationPosts[index].userFans.splice(findIndex, 1)
      }
      if (this.InformationPosts[index].likeUser.length) {
        let likeIndex = this.InformationPosts[index].likeUser.findIndex(s => { return s === this.userInfo.objectId })
        this.InformationPosts[index].likeUser.splice(likeIndex, 1)
      }
      await this.$tkParse.put(`/classes/InformationPosts/${item.objectId}`, { userFans: this.InformationPosts[index].userFans, likeUser: this.InformationPosts[index].likeUser })
      let res = await this.$tkParse.getList('/classes/praisePosts', {
        params: {
          limit: 1,
          where: {
            praiseUser: this.InformationPosts[index].author.objectId,
            userFans: this.userInfo.objectId,
            InformationPosts: this.InformationPosts[index].objectId
          }
        }
      })
      if (res.length) {
        await this.$tkParse.delete(`/classes/praisePosts/${res[0].objectId}`)
      }
      this.$tkGlobal.toast.add('取消成功')
      setTimeout(() => { this.praiseDisable = false }, 500)
      this.$forceUpdate()
    },
    /**
     * 跳转到帖子详情
     * @date: 2020/3/26
     */
    async goPostsDetail (s, index) {
      if (!s) {
        this.InformationPosts.splice(index, 1)
        return this.$tkGlobal.toast.add('此帖子已被删除')
      }
      if (!await this.judgeId(s.objectId, 'InformationPosts')) {
        this.InformationPosts.splice(index, 1)
        return this.$tkGlobal.toast.add('此帖子已被删除')
      }
      this.$push({ path: '/community/postsDetail', query: { id: s.objectId } })
    },
    /**
     * 切换输入框的显示
     * @date: 2020/3/30
     */
    changeCommentsStatus (s) {
      this.isCommentsShow = !this.isCommentsShow
      this.recipient = null
      this.reviewsData = null
      this.placeholder = '评论'
      this.commentsPosts = null
      this.commentsPosts = s
    },
    /**
     * 失去焦点
     * @date: 2020/3/26
     */
    getBlur () {
      this.isCommentsShow = false
      this.styleHeight = 62
    },
    /**
     * 长按操作
     * @date: 2020/8/21
     */
    gtouchstart (e, recipient, data, s, index) {
      this.timeOutEvent = setTimeout(() => {
        this.longPress(e, recipient, data, s, index)
      }, 100)
      return false
    },
    /**
     * 手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
     * @date: 2020/8/21
     */
    gtouchend (recipient, data, s, index) {
      clearTimeout(this.timeOutEvent)// 清除定时器
      if (this.timeOutEvent !== 0) {
        // 这里写要执行的内容（尤如onclick事件）
        // alert('你这是点击，不是长按')
        // recipient 接收人 replytoe 回复人
        if (!recipient) { return this.$tkGlobal.toast.add('未找到您要回复用户的信息') }
        if (recipient.objectId === this.userInfo.objectId) { return this.$tkGlobal.toast.add('您不能回复自己哦') }
        this.isCommentsShow = true
        this.reviewsData = data // 获取评论的信息
        this.recipient = recipient // 获取接收人信息
        this.commentsPosts = s
        this.reviewsIndex = index
        this.placeholder = `回复${recipient.name}：` // 改变placeholder
        this.$forceUpdate()
      }
      return false
    },
    /**
     * 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
     * @date: 2020/8/21
     */
    gtouchmove () {
      clearTimeout(this.timeOutEvent) // 清除定时器
      this.timeOutEvent = 0
    },
    /**
     * 真正长按后应该执行的内容
     * @date: 2020/8/21
     */
    longPress (e, recipient, data, s, index) {
      if (recipient.objectId !== this.userInfo.objectId &&
        s.author.objectId !== this.userInfo.objectId) {
        return
      }
      this.deleteRender = {
        recipient: {},
        commentsPosts: {},
        data: {},
        index: 0
      }
      this.timeOutEvent = 0
      // 执行长按要执行的内容，如弹出菜单
      this.deleteRender = {
        recipient: recipient,
        data: data,
        commentsPosts: s,
        index: index
      }
      this.clientTop = e.changedTouches['0'].clientY
      this.clientLeft = e.changedTouches['0'].clientX
      this.isShowTouch = true
    },
    /**
     * 删除自己跟帖评论或回复评论人
     * @date: 2020/8/20
     */
    async deleteSelfReplytoe () {
      let recipient = this.deleteRender.recipient
      let index = this.deleteRender.index
      let s = this.deleteRender.commentsPosts
      this.isShowTouch = false
      if (recipient.objectId !== this.userInfo.objectId &&
        s.author.objectId !== this.userInfo.objectId) { return }
      await this.subDelEnter(index, s)
    },
    /**
     * 删除跟帖评论
     * @date: 2020/8/20
     */
    async subDelEnter (index, s) {
      if (this.enterLoading) {
        return this.$tkGlobal.toast.add('您点的太快了')
      }
      if (!s.reviewsPostsList[index]) {
        return this.$tkGlobal.toast.add('未找到该评论信息')
      }
      this.enterLoading = true
      s.reviewsPostsList.splice(index, 1)
      await this.$tkParse.put(`/classes/InformationPosts/${s.objectId}`, {
        reviewsPostsList: s.reviewsPostsList
      }).catch(e => {
        this.enterLoading = false
        throw this.$tkGlobal.toast.add('删除跟帖评论失败')
      })
      // 更新页面
      this.$tkGlobal.toast.add('跟帖评论删除成功')
      await this.$tkHelper.sleep(500)
      this.enterLoading = false
      this.$forceUpdate()
    },
    /**
    * 删除回复信息
    * @date: 2020/9/15
    */
    async deleteReplyToe (replytoe, s, index, idIndex) {
      if (this.isDelReplytoe) {
        return this.$tkGlobal.toast.add('您点的太快了')
      }
      if (replytoe.objectId !== this.userInfo.objectId) {
        return this.$tkGlobal.toast.add('您没有该权限')
      }
      this.isDelReplytoe = true
      await this.$tkHelper.sleep(300)
      s.reviewsPostsList[index].whatToReply.splice(idIndex, 1)
      await this.$tkParse.put(`/classes/InformationPosts/${s.objectId}`, {
        reviewsPostsList: s.reviewsPostsList
      }).catch(e => {
        this.isDelReplytoe = false
        throw this.$tkGlobal.toast.add('删除回复信息失败')
      })
      // 更新页面
      this.$tkGlobal.toast.add('回复信息删除成功')
      await this.$tkHelper.sleep(500)
      this.isDelReplytoe = false
      this.$forceUpdate()
    },
    /**
     * 复制评论
     * @date: 2020/8/21
     */
    copyReviews () {
      copy(this.deleteRender.data.reviewerContent).then(s => {
        this.isShowTouch = false
        this.$tkGlobal.toast.add('复制评论成功')
      }).catch(e => {
        this.$tkGlobal.toast.add('复制评论失败')
      })
    },
    /**
     * 回复他人评论
     * @date: 2020/3/26
     */
    enterReplytoe (recipient, data, s, index) {
      // recipient 接收人 replytoe 回复人
      if (!recipient) { return this.$tkGlobal.toast.add('未找到您要回复用户的信息') }
      if (recipient.objectId === this.userInfo.objectId) { return this.$tkGlobal.toast.add('您不能回复自己哦') }
      this.isCommentsShow = true
      this.reviewsData = data // 获取评论的信息
      this.recipient = recipient // 获取接收人信息
      this.commentsPosts = s
      this.reviewsIndex = index
      this.placeholder = `回复${recipient.name}：` // 改变placeholder
      this.$forceUpdate()
    },
    // 给帖子发送评论或回复其他人的评论
    async enterComments () {
      // 判断是否为评论
      if (!this.commentsPosts) { return this.$tkGlobal.toast.add('未找到您要评论的帖子') }
      let isPosts = await this.judgeId(this.commentsPosts.objectId, 'InformationPosts')
      if (!isPosts) {
        this.$tkGlobal.toast.add('该帖已被删除')
        return
      }
      if (!this.comments) { return this.$tkGlobal.toast.add('评论内容不能为空') }
      // 获取最新的帖子评论信息
      let commentsPosts = await this.$tkParse.getList(`/classes/InformationPosts`, { params: { limit: 1, include: 'author', where: { objectId: this.commentsPosts.objectId } } })
      this.commentsPosts = commentsPosts[0]
      // 获取服务器时间 即现在时间
      let nowTime = await this.$tkParse.getData(`https://api.mokekeji.com/time`)
      if (this.recipient && this.reviewsData) { // 回复信息
        this.reviewsData = this.commentsPosts.reviewsPostsList[this.reviewsIndex]
        if (!this.reviewsData.whatToReply) { this.reviewsData.whatToReply = [] }
        let obj = {
          date: nowTime,
          content: this.comments,
          replytoe: this.userInfo,
          recipient: this.recipient
        }
        this.reviewsData.whatToReply.push(obj)
        // 更新页面数据显示
        this.commentsPosts.reviewsPostsList[this.reviewsIndex] = this.reviewsData
        // 修改评论信息
        await this.$tkParse.put(`/classes/InformationPosts/${this.commentsPosts.objectId}`,
          {
            reviewsPostsList: this.commentsPosts.reviewsPostsList
          }
        )
        let index = this.InformationPosts.findIndex(s => { return s.objectId === this.commentsPosts.objectId })
        this.InformationPosts[index] = this.commentsPosts
        this.$tkGlobal.toast.add('回复成功')
        this.recipient = null
        this.reviewsData = null
        this.placeholder = '评论'
        this.commentsPosts = null
      } else { // 评论信息
        if (!this.commentsPosts.commentUser) { this.commentsPosts.commentUser = [] }
        if (!this.commentsPosts.reviewsPostsList) { this.commentsPosts.reviewsPostsList = [] }
        this.commentsPosts.reviewsPostsList.push({
          date: nowTime,
          reviewer: this.userInfo,
          reviewerContent: this.comments
        })
        if (!this.commentsPosts.commentUser.includes(this.userInfo.objectId)) {
          this.commentsPosts.commentUser.push(this.userInfo.objectId)
        }
        await this.$tkParse.put(`/classes/InformationPosts/${this.commentsPosts.objectId}`,
          {
            commentUser: this.commentsPosts.commentUser,
            reviewsPostsList: this.commentsPosts.reviewsPostsList
          }
        )
        let index = this.InformationPosts.findIndex(s => { return s.objectId === this.commentsPosts.objectId })
        this.InformationPosts[index] = this.commentsPosts
        this.$tkGlobal.toast.add('评论成功')
      }
      this.comments = ''
      this.$forceUpdate()
    },
    /**
    * 删除帖子提示
    * @date: 2020/7/28
    */
    deletePost (s, index) {
      this.deletePosts = s
      this.deleteIndex = index
      this.isShowDelete = true
    },
    /**
    * 提交删除
    * @date: 2020/7/28
    */
    async submitDelete () {
      this.spinnerLoading = true
      this.isShowDelete = false
      let s = this.deletePosts
      await this.$tkParse.delete(`/classes/InformationPosts/${s.objectId}`).catch(e => {
        this.spinnerLoading = false
        throw this.$tkGlobal.toast.add('删除帖子失败')
      })
      // 更新页面
      this.InformationPosts.splice(this.deleteIndex, 1)
      await this.$tkHelper.sleep(500)
      this.spinnerLoading = false
      this.deletePosts = null
      this.deleteIndex = 0
      this.$tkGlobal.toast.add('帖子删除成功')
      this.$forceUpdate()
    }
  },
  /**
   * 更新帖子展示
   * @date: 2020/3/25
   */
  async hasFlash () {
    if (this.postsType !== 'news') {
      // 有新发的帖子重新加载该页面
      if (this.$getFlash('newPostsId')) {
        let data = await this.$tkParse.getData(`/classes/InformationPosts/${this.$getFlash('newPostsId')}`)
        data.author = await this.$tkParse.getData(`/classes/_User/${data.author}`)
        if (this.postsType === 'all') {
          this.InformationPosts.unshift(data)
        }
      }
      // 有更新的帖子更新列表数据
      if (this.$getFlash('updatePosts')) {
        let index = this.InformationPosts.findIndex(s => { return s.objectId === this.$getFlash('updatePosts').objectId })
        this.InformationPosts[index] = this.$getFlash('updatePosts')
        this.$forceUpdate()
      }
      // 更新关注信息
      if (this.$getFlash('watchProfile')) {
        let s = this.$getFlash('watchProfile')
        this.InformationPosts.forEach(n => {
          if (n.author.objectId === s.author.objectId) {
            n.isWatch = s.isWatch
          }
        })
        this.$forceUpdate()
      }
    } else { // 更新文章
      let article = this.$getFlash('updateArticle')
      if (article) {
        let index = this.InformationPosts.findIndex(s => { return s.objectId === article.objectId })
        if (index !== -1) {
          this.InformationPosts[index] = article
          this.$forceUpdate()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  /*帖子样式*/
  .posts-card {
    background-color: #fff;
    .post-card-watch {
      min-width: 65px;
      height: 25px;
      font-size: 13px;
      text-align: center;
      line-height: 25px;
      background-color: rgba(245, 245, 245, 1);
      border-radius: 13px;
    }
    .post-card-tips {
      color: rgba(91, 108, 143, 1);
      font-size: 15px;
    }
    .posts-card-image {
      /*border-radius: 5px;*/
      overflow: hidden;
    }
    /*点赞及评论样式*/
    .posts-card-footer {
      min-height: 20px;
      background:rgba(247,247,247,1);
      border: 1px solid #f5f5f5;
      border-radius: 5px;
      .posts-card-footer-top {
        color: rgba(91, 108, 143, 1);
        font-size: 15px;
      }
      .posts-card-footer-bottom-tips {
        color: rgba(91, 108, 143, 1);
      }
      .posts-card-footer-bottom-color {
        font-size: 15px;
        color: rgba(91, 108, 143, 1);
        word-break: break-all;white-space: normal;
      }
      .delete-replytoe {
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 19px;
        border-radius: 50%;
      }
      .posts-card-footer-bottom-active {
        background: #bababa !important;
      }
      .posts-card-footer-bottom-radius {
        border-radius: 0 0 5px 5px;
      }
    }
  }
  /*删除评论弹框样式*/
  .posts-detail-delete {
    position: absolute;
    background: #fff;
    width: 75px;
    height: 110px;
    color: #000;
    padding-left: 15px;
    border-radius: 2px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
  }
  /*输入框样式*/
  .comments {
    border-top: 1px solid #f5f5f5;
    background-color: #f8f6f8;
    padding: 7px 12px 7px 12px;
    .comments-bg {
      background: #fff;
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
    .comments-area {
      height: 100%;
      width: 100%;
      min-width: 0;
      overflow-y: auto;
      resize: none;
      vertical-align: middle;
    }
    .comments-area::placeholder {
      font-size: 14px;
      color: rgba(153, 153, 153, 1);
    }
    .comments-btn {
      padding-left: 10px;
      .comments-btn-enter {
        border-radius: 5px;
        border: 1px solid #dad8d8;
        height: 32px;
        margin: 0;
      }
      ::v-deep .tkui-button.disabled {
        background: #f8f6f8 !important;
        opacity: 1 !important;
        color: #d6d3d6 !important;
      }
    }
  }
  /*返回顶部样式*/
  .back-top {
    position: absolute;
    bottom: 13px;
    right: 13px;
  }
  .back-footer-top {
    position: absolute;
    bottom: 62px;
    right: 13px;
  }
</style>
